import React from "react";
import MobilePage, { PageHeader } from "../../../Components/MobilePage";
import { useTranslation } from "react-i18next";
import Container from "@mui/material/Container";
import AppBar from "../../Components/AppBar";
import { Skeleton } from "@mui/material";
import { useAPI } from "../../../../lib/common";
import { Route } from "react-router";
import { Switch } from "react-router-dom";
const TermsPageRouter = () => {
    const [t] = useTranslation();
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: "/privacy-policy", render: () => (React.createElement(TermsPage, { header: t("Privacy policy"), apiEndpoint: "/api/webshop/privacy-policy", dataKey: "privacyPolicy" })) }),
        React.createElement(Route, { exact: true, path: "/terms-of-service", render: () => (React.createElement(TermsPage, { header: t("Terms of service"), apiEndpoint: "/api/webshop/terms-of-service", dataKey: "termsOfService" })) }),
        React.createElement(Route, { exact: true, path: "/terms-of-purchase", render: () => (React.createElement(TermsPage, { header: t("Terms of purchase"), apiEndpoint: "/api/webshop/terms-of-purchase", dataKey: "termsOfPurchase" })) }),
        React.createElement(Route, { exact: true, path: "/cookies-description", render: () => (React.createElement(TermsPage, { header: t("Cookies"), apiEndpoint: "/api/webshop/cookies-description", dataKey: "cookiesDescription" })) })));
};
const TermsPage = ({ header, apiEndpoint, dataKey, }) => {
    var _a, _b;
    const { i18n } = useTranslation();
    const [data, isLoading] = useAPI(apiEndpoint + `?lang=${i18n.language}`);
    const content = (_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a[dataKey]) !== null && _b !== void 0 ? _b : "";
    // Privacy policy might contain html:
    return (React.createElement(MobilePage, null,
        React.createElement(AppBar, null),
        React.createElement(PageHeader, null, header),
        React.createElement(Container, null,
            isLoading && React.createElement(TextSkeleton, null),
            !isLoading && (React.createElement("div", { dangerouslySetInnerHTML: {
                    __html: content.replace(/\n/g, "<br />"),
                } })))));
};
const TextSkeleton = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Skeleton, { variant: "text" }),
        React.createElement(Skeleton, { variant: "text" }),
        React.createElement(Skeleton, { variant: "text" }),
        React.createElement("br", null),
        React.createElement(Skeleton, { variant: "text" }),
        React.createElement(Skeleton, { variant: "text" })));
};
export default TermsPageRouter;
